module.exports = __webpack_public_path__ + "img/g-globe.cc1437bd.png";